import "@fontsource-variable/inter";
import "@fontsource-variable/source-serif-4";
import "@fontsource-variable/source-serif-4/wght-italic.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initBrowserTelemetry } from "@iamu/telemetry/browser";
import { initPostHog } from "@/lib/posthog";
import { App } from "./App.tsx";
import "./index.css";

async function boot() {
  initPostHog();

  await initBrowserTelemetry({
    serviceName: "iamu-dashboard",
    release: import.meta.env.VITE_APP_RELEASE,
    environment: import.meta.env.MODE,
    baseUrl: import.meta.env.VITE_OTEL_URL,
    excludeTodo: true,
  });

  if (import.meta.env.VITE_MSW === "true") {
    const { worker } = await import("./mocks/browser.js");
    await worker.start({ onUnhandledRequest: "warn" });
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

boot();
